export default {
  title: 'Configuraciones',

  errors: {
    componentNotFound: 'Componente para la clave <b>{key}</b> no encontrado.'
  }
}
